import { useQuery } from '@tanstack/react-query';

import { ExternalApiService } from '../../../services';
import { type IDPECMConfig } from '../../../services/types';

export interface ConfigItem {
  configname: string;
  configdata: string;
}

export interface ConfigResponse {
  configkeys: ConfigItem[];
}
/*

*/

const fetchConfig = async (): Promise<ConfigResponse> => {
  const payload = {
    configkeys: ['ID_PROOFING_SESSION_EXPIRE_HOURS'],
  } as IDPECMConfig;

  const response = (await ExternalApiService.postECMConfig(
    payload
  )) as ConfigResponse;

  return response;
};

const useFetchConfig = () =>
  useQuery<ConfigResponse>({
    queryKey: ['config'],
    queryFn: fetchConfig,
    refetchOnWindowFocus: false,
  });

export default useFetchConfig;
